import type { CortexEventLogRow } from "@flowstate/types";
import { redactSecretsDeep } from "./redact-secrets";

/**
 * Serialize a console event for clipboard paste (debugging / agent handoff).
 * Secrets (tokens, API keys) are redacted before copy.
 */
export function formatEventForClipboard(event: CortexEventLogRow): string {
  return JSON.stringify(redactSecretsDeep(event), null, 2);
}

export async function copyEventToClipboard(
  event: CortexEventLogRow,
): Promise<boolean> {
  const text = formatEventForClipboard(event);
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to execCommand path
  }

  try {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "fixed";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}
